export class CdnConfigToken {
  static ICdnConfigurationRepository = Symbol("ICdnConfigurationRepository");
  static CdnConfigurationUseCase = Symbol("CdnConfigurationUseCase");
  static CdnConfigurationViewModel = Symbol("CdnConfigurationViewModel");
}
